"use client"

import {
  NavigateWithThread,
  buildCandidateOpportunityMatchPath,
  getHrefWithThreadPreservation,
} from '@yeshuman/sdk'
import { useParams } from 'react-router-dom'

export function CandidateEvaluationAnalysisRoute() {
  const { evaluationId } = useParams<{ evaluationId: string }>()

  if (!evaluationId) {
    return <NavigateWithThread to="/candidate/jobs?tab=saved" />
  }

  const target = buildCandidateOpportunityMatchPath(evaluationId, { tab: 'analysis' })

  return <NavigateWithThread to={getHrefWithThreadPreservation(target)} />
}
